/**
 * Reusable empty state — friendly headline, sub-copy, single primary CTA.
 * Used across doctor-side editors when a list is genuinely empty (not
 * loading, not filtered-away) so the user always knows the next action.
 */
export default function EmptyState({ icon: Icon, title, subtitle, cta, onCta, testId = "empty-state" }) {
    return (
        <div className="text-center py-14 px-4" data-testid={testId}>
            {Icon && (
                <div className="mx-auto h-14 w-14 rounded-full bg-[#123B5D]/5 flex items-center justify-center mb-4">
                    <Icon size={22} className="text-[#123B5D]/60" />
                </div>
            )}
            <div className="text-[#123B5D] font-semibold text-base" data-testid={`${testId}-title`}>{title}</div>
            {subtitle && (
                <div className="text-sm text-[#17212B]/60 mt-1 max-w-md mx-auto">{subtitle}</div>
            )}
            {cta && onCta && (
                <button
                    className="mt-6 inline-flex items-center gap-1.5 rounded-full bg-[#123B5D] text-white text-sm font-semibold px-4 py-2 hover:bg-[#0F1B2D]"
                    onClick={onCta}
                    data-testid={`${testId}-cta`}
                >
                    {cta}
                </button>
            )}
        </div>
    );
}
